exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#qrcode[data-v-29605c04]{margin:auto;width:250px}", ""]);

// exports
